/* src/app/views/admin/message/message.component.css */
/*# sourceMappingURL=message.component.css.map */
